import {
  generateLanguageQuery,
  optionalImage,
  optionalQuery,
  tipsArray
} from '@/services/dataStore/queries/fragments'

const layerValuesArray = (isReferenceArticle: boolean) => `
  layerValues[]->{
    'key': _id,
    'name': ${generateLanguageQuery('name')},
    ${optionalQuery('tilesetUrl', true)},
    ${optionalQuery('tilesetLayer', true)},
    ${optionalQuery('promoteId', true)},
    interactive,
    headings,
    muted,
    style,
    'styleConfig': {
      color,
      exclude,
      ${optionalQuery('radius', true)},
      defined(pointIcon) => {
        'pointIcon': pointIcon.asset->{url, assetId}
      },
      ${optionalQuery('opacity', false)},
      ${optionalQuery('targetAttribute', true)},
      ${optionalQuery('minValue', false)},
      ${optionalQuery('maxValue', false)},
      ${optionalQuery('imageId', true, 'image')},
      ${optionalQuery('modulus', false)},
      ${optionalQuery('modulator', true)}
    },
    'layerConfig': {
      ${optionalQuery('layerMinZoom', false, 'minzoom')},
      ${optionalQuery('layerMaxZoom', false, 'maxzoom')},
      ${optionalQuery('layerMapboxFilter', true, 'filter')}
    },
    'labelConfig': {
      ${optionalQuery('labelMinZoom', false, 'minzoom')},
      ${optionalQuery('labelMapboxFilter', true, 'filter')}
    },
    ${
      isReferenceArticle
        ? `dataSources[]->{
            _id,
            'name': ${generateLanguageQuery('name')},
            sourceUrl,
            sourceName,
            lastUpdatedYear
          },`
        : ''
    }
  }
`

const dataLayerProjection = (isReferenceArticle: boolean) => `
  'key': _id,
  name,
  'layerType': type,
  isGradient,
  showGreaterThan,
  emptyIsNoData,
  basemapTweaks,
  ${optionalImage('mapScreenshot')},
  'lastUpdatedYear': _updatedAt,
  shortDescription,
  ${
    isReferenceArticle
      ? `
        longDescription,
        "methodology": {
          "blocks": methodology
        },
        ${tipsArray},`
      : ''
  }
  "es": *[_type == "translation.metadata" && references(^._id)].translations[_key == "es"].value->{
    name,
    shortDescription,
    ${
      isReferenceArticle
        ? `longDescription,
          "methodology": {
            "blocks": methodology
          },`
        : ''
    }
  },
  ${layerValuesArray(isReferenceArticle)},
`

export const dataLayersQuery = () =>
  `*[_type == "dataLayer" && language == "en" && hidden != true] {
    ${dataLayerProjection(false)}
  }`

export const singleDataLayerQuery = (
  dataLayerKey: string,
  isReferenceArticle: boolean
) =>
  `*[_type == "dataLayer" && language == "en" && _id == "${dataLayerKey}"] {
    ${dataLayerProjection(isReferenceArticle)}
  }`
